import { LoadingPlaceholder } from 'genesys-react-components';
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';

import LayoutController from './components/layouts/LayoutController';
import PrivacyBanner from './components/privacybanner/PrivacyBanner';
import { DataCollector } from './helpers/datacollector/DataCollector';

// Commence data harvesting
DataCollector.init();

export default function App() {
	return (
		<RecoilRoot>
			<RecoilNexus />
			{/* This loading fallback is triggered by asynchronously initialized atoms */}
			<Suspense fallback={<LoadingPlaceholder />}>
				<BrowserRouter>
					<LayoutController />
					<PrivacyBanner />
				</BrowserRouter>
			</Suspense>
		</RecoilRoot>
	);
}
